<template>
  <div class="substance">
    <!-- 轮播图部分 -->
    <div class="container">
      <div class="flexcenter">
        <div class="carousel">
          <div class="block">
            <!-- 轮播图 -->
            <el-carousel class="elcarousel" v-model="currentIndex">
              <el-carousel-item v-for="(item, index) in carouselarr" :key="index">
                <img v-show="item.id == 1" src="@/assets/image/lot.png" alt="">
                <img v-show="item.id == 2" style="width: 100%;height: 100%;" src="@/assets/image/lot1.png" alt="">
                <img v-show="item.id == 3" src="@/assets/image/lot2.png" alt="">
                <div>
                  <p>{{ item.value }}</p>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="connected ">
          <div class="title-box">
            <div class="main"></div>
            <p>已诉调对接案件（件）</p>
            <div class="tips">CASE</div>
          </div>
          <div class="address">
            <img src="../assets/image/dingwei.png" alt="">
            <span>{{ address }}</span>
          </div>
          <div class="count-box">
            <p v-for="(item, index) in countbox" :key="index">{{ item }}</p>
          </div>
          <button @click="CaseInquiry">案件查询</button>
          <div class="title-box">
            <div class="main"></div>
            <p>投诉监督电话</p>
            <div class="tips">PHONE</div>
          </div>
          <div class="supervision">
            <img src="../assets/image/phone.png" alt="">
            <h2>{{ phone }}</h2>
          </div>
        </div>
      </div>
      <!-- 案件数量 -->
      <div class="index-shadow">
        <div class="shadow_zztz">
          <img src="../assets/image/case1.png" alt="">
          <div class="shadow_title">
            <p>{{ indexshadow[0].title }}</p>
            <span>{{ indexshadow[0].num }}</span>
          </div>
        </div>
        <div class="line"></div>
        <div class="shadow_zztz">
          <img src="../assets/image/case2.png" alt="">
          <div class="shadow_title">
            <p>{{ indexshadow[1].title }}</p>
            <span>{{ indexshadow[1].num }}</span>
          </div>
        </div>
        <div class="line"></div>
        <div class="shadow_zztz">
          <img src="../assets/image/case3.png" alt="">
          <div class="shadow_title">
            <p>{{ indexshadow[2].title }}</p>
            <span>{{ indexshadow[2].num }}</span>
          </div>
        </div>
        <div class="line"></div>
        <div class="shadow_zztz">
          <img src="../assets/image/case4.png" alt="">
          <div class="shadow_title">
            <p>{{ indexshadow[3].title }}</p>
            <span>{{ indexshadow[3].num }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flow_path">
      <div class="flow_Jflcpath">
        <div class="flowtitle">
          <p>金融纠纷调解流程</p>
          <span>FINANCIAL DISPUTE RESOLUTION PROCESS</span>
        </div>
        <img src="../assets/image/f1.png" alt="">
      </div>
      <!-- <div style="height: 500px;"></div> -->
      <div class="flow_Jflcpath">
        <div class="flowtitle">
          <p>金融纠纷诉调对接流程</p>
          <span>FINANCIAL DISPUTE LITIGATION AND MEDIATION PROCESS</span>
        </div>
        <img src="../assets/image/f2.png" alt="">
      </div>
      <div class="flow_Jflcpath">
        <div class="flowtitle">
          <p>金融纠纷审判流程</p>
          <span>FINANCIAL DISPUTE ADJUDICATION PROCESS</span>
        </div>
        <img src="../assets/image/f3.png" alt="">
      </div>
      <div class="flow_Jflcpath">
        <div class="flowtitle">
          <p>金融纠纷强制执行流程</p>
          <span>FINANCIAL DISPUTE ENFORCEMENT PROCESS</span>
        </div>
        <img src="../assets/image/f4.png" alt="">
      </div>
      <div class="flow_Jflcpath">
        <div class="flowtitle">
          <p>关于我们</p>
          <span>ABOUT US</span>
        </div>
        <div class="flow_abour">
          <p v-if="resolution == 1">
            根据《中华人民共和国人民调解法》、司法部《关于行业性专业性人民调解组织建设的指导意见》、《湖南省矛盾纠纷多元化解条例》等相关文件的有关规定，成立“常宁市数科纠纷调解中心”。
            <br>
            常宁市数科纠纷调解中心经常宁市司法局备案登记，常宁市数科纠纷调解中心主要是对各类社会矛盾纠纷进行调解的“非盈利性质服务机构”。
          </p>
          <p v-if="resolution == 2">
            为完善社会矛盾纠纷多元综合化解机制，实现解纷方式由单一审判机关向社会联动的转变，探索构建公益性调解与市场化调解并行的解纷模式，高效、便捷化解网络消费、金融等纠纷，襄阳市首家民办非企业单位性质的网络金融纠纷调解中心——襄阳市襄州区网络金融纠纷调解中心经襄州区司法局核准备案，在襄州区行政审批局登记成立，进一步充实了矛盾纠纷多元化解工作。
            <br>
            该中心的成立，是深入贯彻“完善社会矛盾多元预防调处化解综合机制”、“坚持把非诉讼纠纷解决机制挺在前面”要求的基层实践，有利于深入推进社会矛盾化解，迅速定纷止争，大力减轻法院执行压力。
          </p>
          <p v-if="resolution == 3">
            为完善社会矛盾纠纷多元综合化解机制，实现解纷方式由单一审判机关向社会联动的转变，探索构建公益性调解与市场化调解并行的解纷模式，高效、便捷化解受理调解平等主体的法人，白然人与其他组织之间的金融、保险纠纷以及其他商事领域的纠纷调解、金融诉讼，进行普法宣传及纠纷调解，天门市民办非企业单位性质的调解中心—天门市正合多元调解中心经天门市司法局核准备案，在天门市民政局登记成立，进一步充实了矛盾纠纷多元化解工作。
            <br>
            该中心的成立，是深入贯彻“完善社会矛盾多元预防调处化解综合机制”、“坚持把非诉讼纠纷解决机制挺在前面”要求的基层实践，有利于深入推进社会矛盾化解，迅速定纷止争，大力减轻法院执行压力。
          </p>
          <p v-if="resolution == 4">
            <br>
          </p>
          <p v-if="resolution == 5">
            为完善社会矛盾纠纷多元综合化解机制，实现解纷方式由单一审判机关向社会联动的转变，探索构建公益性调解与市场化调解并行的解纷模式，高效、便捷化解受理调解平等主体的法人，自然人与其他组织之间的金融、保险纠纷以及其他商事领域的纠纷调解、金融诉讼，进行普法宣传及纠纷调解，依照章程开展活动，荆门市民办非企业单位性质的调解中心—荆门市掇刀区商事仲裁调解服务中心经天门市司法局核准备案，在荆门市掇刀区行政审批局登记成立，进一步充实了矛盾纠纷多元化解工作。
            <br>
            该中心的成立，是深入贯彻“完善社会矛盾多元预防调处化解综合机制”、“坚持把非诉讼纠纷解决机制挺在前面”要求的基层实践，有利于深入推进社会矛盾化解，迅速定纷止争，大力减轻法院执行压力。
          </p>
          <p v-if="resolution == 6">
            为完善社会矛盾纠纷多元综合化解机制，实现解纷方式由单一审判机关向社会联动的转变，探索构建公益性调解与市场化调解并行的解纷模式，高效、便捷化解依法受理调解法人、自然人和其他社会组织的金融纠纷、相关法律知识宣传及多元解纷机制理论研究，属于汉中市民办非企业单位性质的调解中心—汉中市洋县纠纷调解中心经洋县金融工作办公室核准备案，在汉中市洋县行政审批局登记成立，进一步充实了矛盾纠纷多元化解工作。
            <br>
            该中心的成立，是深入贯彻“完善社会矛盾多元预防调处化解综合机制”、“坚持把非诉讼纠纷解决机制挺在前面”要求的基层实践，有利于深入推进社会矛盾化解，迅速定纷止争，大力减轻法院执行压力。
          </p>
          <p v-if="resolution == 7">
            枣强曙光商事调解中心是按照国家推进金融纠纷多元化解机制建设的相关政策精神设立的非诉讼第三方金融纠纷调解组织，由枣强县司法局担任业务主管单位，2023年12月12日，枣强曙光商事调解中心在枣强县民政局完成注册登记，2024年1月13日，枣强曙光商事调解中心举行揭牌仪式，正式营业。
            <br>
            贯彻落实党中央、国务院关于推进矛盾纠纷多元化解机制的相关要求，依据国家金融法律法规及相关规定，按照“依法公正、调解自愿、高效便民”原则，对各类金融消费纠纷进行社会化调解，开展金融消费者权益保护方面的信息交流和金融知识普及，保护金融消费者合法权益，促进金融稳定和社会和谐。
          </p>

        </div>
      </div>
    </div>
    <div class="guide">
      <div class="guide_Fwzn">
        <div class="manual">
          <p>诉讼服务指南</p>
          <span @click="more('5', '')">查看更多 ></span>
        </div>
        <ul>
          <li @click="more('5', '1')">
            <p>老赖”生活的限制，一文讲清！</p>
            <span>2023-05-25</span>
          </li>
          <li @click="more('5', '2')">
            <p>视点深度｜首度亮相的民事强制执行法草案亮点解析</p>
            <span>2023-05-25</span>
          </li>
          <li @click="more('5', '3')">
            <p>限制“老赖”措施汇总（2022年版）</p>
            <span>2023-05-25</span>
          </li>
        </ul>
      </div>
      <div class="guide_Fwzn">
        <div class="manual">
          <p>解纷指南</p>
          <span @click="more('6', '')">查看更多 ></span>
        </div>
        <ul>
          <li @click="more('6', '1')">
            <p>中华人民共和国人民调解法</p>
            <span>2023-12-15</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SubsTance",
  data() {
    return {
      countbox: "3461", //已对接案件
      //案件数据
      indexshadow: [
        {
          title: "正在调查案件",
          num: "3297"
        },
        {
          title: "已正式立案案件",
          num: "887"
        },
        {
          title: "已判决案件",
          num: "563"
        },
        {
          title: "已执行案件",
          num: "469"
        }
      ],
      currentIndex: "1",
      carouselarr: [
        {
          id: 1,
          value:
            "最高人民法院 中国人民银行 中国银行保险监督管理委员会 印发《关于全面推进金融纠纷多元化解机制建设的意见》的通知"
        },
        {
          id: 2,
          value: "最高人民法院工作报告（全文）"
        },
        {
          id: 3,
          value: "十四届全国人大一次会议在京闭幕 习近平发表重要讲话"
        }
      ],
      chart: "",
      resolution: "",
      address: "", //地址
      phone: "" //监督电话
    };
  },
  mounted() {
    if (JSON.parse(sessionStorage.getItem("resolution"))) {
      this.resolution = JSON.parse(sessionStorage.getItem("resolution"));
      if (this.resolution == 1) {
        this.address = "常宁市";
        this.phone = "0734-7298911";
      } else if (this.resolution == 2) {
        this.address = "襄阳市";
        this.phone = "0710-3337535";
      } else if (this.resolution == 3) {
        this.address = "天门市";
        this.phone = "4009261971";
      } else if (this.resolution == 4) {
        this.address = "山西市";
        this.phone = "4008-916578";
      } else if (this.resolution == 5) {
        this.address = "荆门市";
        this.phone = "4009155317";
      } else if (this.resolution == 6) {
        this.address = "汉中市";
        this.phone = "0916-8216386";
      } else if (this.resolution == 7) {
        this.address = "衡水市";
        this.phone = "0318-8386118";
      }
    }
  },
  methods: {
    more(a, b) {
      this.$emit("more", [a, b]);
    },
    CaseInquiry() {
      // const externalUrl = 'http://hb.zqsgtj.cn:2/login';//保留当前页面打开
      // window.location.href = externalUrl;
      const url = 'http://xcx.zqsgtj.cn:9081/?j=ZQ';//打开一个新的页面
      window.open(url, '_blank');
    }
  },
  watch: {
    chart(val, older) { },
    immediate: true
  }
};
</script>
<style lang="less" scoped>
.substance {
  width: 100%;
  margin-top: 50px;

  .container {
    width: 1196px;
    height: 576px;
    // background: rgb(72, 255, 0);
    margin: 0 auto;

    .flexcenter {
      width: 100%;
      height: 427px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .carousel {
        width: 770px;
        height: 427px;

        .block {
          width: 100%;
          height: 100%;
          background: #6c6c6c;
          position: relative;
          border-radius: 5px;
          overflow: hidden;

          div {
            width: 100%;
            position: absolute;
            bottom: 0px;
            background: rgba(0, 0, 0, 0.8);
            color: #fff;

            p {
              width: 400px;
              padding: 10px;
              white-space: nowrap;
              /* 禁止文本换行 */
              overflow: hidden;
              /* 溢出内容隐藏 */
              text-overflow: ellipsis;
            }
          }
        }
      }

      .connected {
        width: 395px;
        height: 420px;

        .title-box {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          margin-bottom: 20px;

          .tips {
            color: #000;
            font-family: EnLightFont;
            text-align: center;
            position: absolute;
            width: 100%;
            left: 0;
            bottom: -7px;
            opacity: 0.15;
            line-height: 24px;
          }

          p {
            width: 100%;
            color: #be1a0f;
            font-family: BoldFont;
            text-align: center;
            line-height: 24px;
            font-weight: bold;
            font-size: 22px;
          }
        }

        .title-box::after {
          content: "";
          position: absolute;
          height: 1px;
          width: 70px;
          top: 11px;
          left: 0;
          background: linear-gradient(to right,
              rgba(190, 26, 15, 0),
              rgba(190, 26, 15, 1));
        }

        .title-box::before {
          content: "";
          right: 0;
          background: linear-gradient(to left,
              rgba(190, 26, 15, 0),
              rgba(190, 26, 15, 1));
          position: absolute;
          height: 1px;
          width: 70px;
          top: 11px;
        }

        .address {
          width: 100%;
          height: 24px;
          margin-bottom: 32px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }

        .count-box {
          width: 100%;
          height: 82px;
          display: flex;
          justify-content: space-around;
          align-items: center;

          p {
            width: 56px;
            height: 82px;
            background: #ffffff;
            border: 3px solid #dedede;
            border-radius: 5px;
            overflow: hidden;
            font-family: MediumFont;
            font-size: 36px;
            font-weight: 600;
            text-align: center;
            line-height: 82px;
          }
        }

        button {
          display: block;
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #be1a0f;
          border-radius: 5px;
          color: #fff;
          margin: 40px 0 50px 0;
          font-family: MediumFont;
          font-size: 20px;
          border: 0;
        }

        button:hover {
          background: #9d1309;
        }

        .supervision {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 30px;

          img {
            margin-right: 10px;
          }

          p {
            width: 100px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #be1a0f;
            border-radius: 5px;
            color: #fff;
            font-family: MediumFont;
            font-size: 16px;
            border: 0;
          }
        }
      }
    }

    .index-shadow {
      width: 100%;
      // height: 119px;
      margin-top: 30px;
      background: #fff;
      border-radius: 5px;
      padding: 25px 0;
      box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
      display: flex;
      justify-content: space-around;

      .shadow_zztz {
        width: 185px;
        height: 69px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img {
          width: 69px;
        }

        .shadow_title {
          p {
            font-size: 16px;
            color: #393939;
            margin-bottom: 14px;
          }

          span {
            font-size: 24px;
            color: #be1a0f;
          }
        }
      }

      .line {
        width: 1px;
        height: 33px;
        background: #393939;
        opacity: 0.3;
        margin-top: 20px;
      }
    }
  }

  .flow_path {
    width: 1196px;
    height: 100%;
    // background: rgb(72, 255, 0);
    margin: 0 auto;
    margin-top: 40px;

    .flow_Jflcpath {
      width: 100%;
      position: relative;
      margin-bottom: 30px;

      .flowtitle {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          font-size: 20px;
          color: #be1a0f;
        }

        span {
          color: #393939;
          opacity: 0.15;
          font-family: EnLightFont;
          letter-spacing: 3px;
        }
      }

      .flowtitle::after {
        content: "";
        position: absolute;
        width: 1196px;
        height: 1px;
        top: 35px;
        background: linear-gradient(to left,
            rgba(190, 26, 15, 0),
            rgba(190, 26, 15, 1));
      }

      img {
        width: 100%;
        height: 290px;
        margin-top: 25px;
        border-radius: 5px;
        box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
      }

      .flow_abour {
        width: 100%;
        height: 100%;
        box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
        background: #ffffff;
        border-radius: 5px;

        p {
          padding: 25px;
          margin-top: 25px;
          letter-spacing: 2px;
          line-height: 25px;
        }
      }
    }
  }

  .guide {
    width: 1196px;
    height: 100%;
    // background: rgb(72, 255, 0);
    margin: 0 auto;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;

    .guide_Fwzn {
      width: 550px;
      height: 394px;
      background: #fff;
      border-radius: 5px;
      padding: 22px 19px 20px;
      box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
      position: relative;

      .manual {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        p {
          color: #be1a0f;
          font-family: MediumFont;
          font-size: 20px;
        }

        span {
          font-size: 14px;
          color: #999999;
        }
      }

      .manual:hover span {
        color: #be1a0f;
      }

      .manual::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        top: 60px;
        background: linear-gradient(to left,
            rgba(190, 26, 15, 0),
            rgba(190, 26, 15, 1));
      }

      ul {
        height: 300px;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        list-style: none;
        position: relative;
        overflow: hidden;

        li::after {
          content: "";
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #be1a0f;
          position: absolute;
          left: 0;
          // top: 7px;
        }

        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-left: 20px;

          p {
            font-size: 14px;
          }

          span {
            font-size: 14px;
            color: #999999;
          }
        }

        li:hover p {
          color: #be1a0f;
        }

        li:hover span {
          color: #be1a0f;
        }
      }
    }
  }
}

.currentIndex {
  font-size: 16px;
}

@media screen and (max-width: 1200px) {
  .substance {
    width: 100%;
    margin-top: 30px;

    .container {
      width: 100%;
      height: 100%;
      // background: rgb(72, 255, 0);
      margin: 0 auto;

      .flexcenter {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;

        .carousel {
          width: 95%;
          height: 200px;
          margin-top: 10px;

          .block {
            width: 100%;
            height: 100%;
            background: #6c6c6c;
            position: relative;
            border-radius: 5px;
            overflow: hidden;

            div {
              width: 100%;
              position: absolute;
              bottom: 0px;
              background: rgba(0, 0, 0, 0.8);
              color: #fff;

              p {
                width: 300px;
                padding: 10px;
                white-space: nowrap;
                /* 禁止文本换行 */
                overflow: hidden;
                /* 溢出内容隐藏 */
                text-overflow: ellipsis;
              }
            }

            .elcarousel {
              height: 200px !important;
            }

            img {
              width: 100%;
              height: 200px;
            }
          }
        }

        .connected {
          width: 395px;
          height: 280px;
          margin-top: 20px;

          .title-box {
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            margin-bottom: 20px;

            .tips {
              color: #000;
              font-family: EnLightFont;
              text-align: center;
              position: absolute;
              width: 100%;
              left: 0;
              bottom: -7px;
              opacity: 0.15;
              line-height: 24px;
            }

            p {
              width: 100%;
              color: #be1a0f;
              font-family: BoldFont;
              text-align: center;
              line-height: 24px;
              font-weight: bold;
              font-size: 15px;
            }
          }

          .title-box::after {
            content: "";
            position: absolute;
            height: 1px;
            width: 70px;
            top: 11px;
            left: 30px;
            background: linear-gradient(to right,
                rgba(190, 26, 15, 0),
                rgba(190, 26, 15, 1));
          }

          .title-box::before {
            content: "";
            right: 0;
            background: linear-gradient(to left,
                rgba(190, 26, 15, 0),
                rgba(190, 26, 15, 1));
            position: absolute;
            height: 1px;
            width: 70px;
            top: 11px;
            right: 30px;
          }

          .address {
            width: 100%;
            height: 24px;
            margin-bottom: 12px;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            span {
              font-size: 14px;
            }

            img {
              width: 15px;
            }
          }

          .count-box {
            width: 100%;
            height: 50px;
            display: flex;
            justify-content: space-around;
            align-items: center;

            p {
              width: 40px;
              height: 50px;
              background: #ffffff;
              border: 3px solid #dedede;
              border-radius: 5px;
              overflow: hidden;
              font-family: MediumFont;
              font-size: 25px;
              font-weight: 600;
              text-align: center;
              line-height: 50px;
            }
          }

          button {
            display: block;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #be1a0f;
            border-radius: 5px;
            color: #fff;
            margin: 20px 0 20px 0;
            font-family: MediumFont;
            font-size: 15px;
            border: 0;
          }

          button:hover {
            background: #9d1309;
          }

          .supervision {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 10px;

            img {
              width: 30px;
              margin-right: 10px;
            }

            p {
              width: 100px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              background: #be1a0f;
              border-radius: 5px;
              color: #fff;
              font-family: MediumFont;
              font-size: 16px;
              border: 0;
            }

            h2 {
              font-size: 20px;
            }
          }
        }
      }

      .index-shadow {
        width: 100%;
        // height: 119px;
        // margin-top: 30px;
        background: #fff;
        border-radius: 5px;
        padding: 10px 0;
        box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
        display: flex;
        justify-content: space-around;

        .shadow_zztz {
          width: 100px;
          height: 69px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;

          img {
            width: 30px;
          }

          .shadow_title {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            p {
              font-size: 13px;
              color: #393939;
              margin-bottom: 0px;
            }

            span {
              font-size: 17px;
              color: #be1a0f;
            }
          }
        }

        .line {
          width: 1px;
          height: 33px;
          background: #393939;
          opacity: 0.3;
          margin-top: 20px;
        }
      }
    }

    .flow_path {
      width: 95%;
      height: 100%;
      // background: rgb(72, 255, 0);
      margin: 0 auto;
      margin-top: 40px;

      .flow_Jflcpath {
        width: 100%;
        position: relative;
        margin-bottom: 30px;

        .flowtitle {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
            font-size: 14px;
            color: #be1a0f;
            margin-right: 10px;
          }

          span {
            display: none;
            color: #393939;
            opacity: 0.15;
            font-family: EnLightFont;
            letter-spacing: 3px;
          }
        }

        .flowtitle::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 1px;
          top: 25px;
          background: linear-gradient(to left,
              rgba(190, 26, 15, 0),
              rgba(190, 26, 15, 1));
        }

        img {
          width: 100%;
          height: 120px;
          margin-top: 25px;
          border-radius: 5px;
          box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
        }

        .flow_abour {
          width: 100%;
          height: 100%;
          box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
          background: #ffffff;
          border-radius: 5px;

          p {
            font-size: 14px;
            padding: 25px;
            margin-top: 25px;
            letter-spacing: 2px;
            line-height: 25px;
          }
        }
      }
    }

    .guide {
      width: 95%;
      height: 100%;
      // background: rgb(72, 255, 0);
      margin: 0 auto;
      margin-top: 0px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      .guide_Fwzn {
        width: 95%;
        height: 100%;
        background: #fff;
        border-radius: 5px;
        padding: 0 10px;
        margin: 10px 0;
        box-shadow: 0px 0px 10px 0px rgba(31, 31, 31, 0.05);
        position: relative;

        .manual {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 10px 0;

          p {
            color: #be1a0f;
            font-family: MediumFont;
            font-size: 15px;
          }

          span {
            font-size: 14px;
            color: #999999;
          }
        }

        .manual:hover span {
          color: #be1a0f;
        }

        .manual::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 1px;
          top: 40px;
          background: linear-gradient(to left,
              rgba(190, 26, 15, 0),
              rgba(190, 26, 15, 1));
        }

        ul {
          height: 100%;
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          list-style: none;
          position: relative;
          overflow: hidden;

          li::after {
            content: "";
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: #be1a0f;
            position: absolute;
            left: 0;
            // top: 7px;
          }

          li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 20px;
            margin: 10px 0;

            p {
              font-size: 14px;
              width: 250px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            span {
              font-size: 14px;
              color: #999999;
            }
          }

          li:hover p {
            color: #be1a0f;
          }

          li:hover span {
            color: #be1a0f;
          }
        }
      }
    }
  }

  .currentIndex {
    font-size: 16px;
  }
}
</style>
